'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment', 'AVRO.Common.Configuration', 'AVRO.Common.DataRetriever'];
module.exports = angular.module('AVRO.Common.OptWeek', dependencies).factory('OptWeekService', require('./services/OptWeekService')).factory('OptWeekReferenceService', require('./services/OptWeekReferenceService'));